import PlusIcon from '../PlusIcon/PlusIcon'
import { GRAYSCALE_300 } from '../../styles/colors'
import { Container, IconContainer, Label } from './AddButton.styles'

export type AddButtonProps = {
    label?: string
    size?: number
    fontSize?: number | string
    $backgroundColor?: string
    $borderColor?: string
    onClick: () => void
    defaultLabel: string
}

const AddButton = ({
    label,
    size = 8,
    fontSize = '13px',
    $backgroundColor = 'transparent',
    $borderColor = GRAYSCALE_300,
    onClick,
    defaultLabel,
}: AddButtonProps) => {
    return <Container
        onClick={onClick}
        $backgroundColor={$backgroundColor}
        $borderColor={$borderColor}
    >
        <IconContainer size={size}>
            <PlusIcon size={size} />
        </IconContainer>
        <Label fontSize={fontSize}>{label || defaultLabel}</Label>
    </Container>
}

export default AddButton
